import React, {useRef, useState} from 'react';
import Image from 'next/image'
import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import LoadingButton from '@mui/lab/LoadingButton';
import Stack from "@mui/material/Stack";
import {IsacoSearchPropsType} from "@/types/isaco";
import {Field} from '@/components/form';
import useMediaQuery from "@mui/material/useMediaQuery";

export default function IsacoSearch({handleSearchPhraseChange, searchPhrase, isLoading}: IsacoSearchPropsType) {
    const theme = useTheme()
    const inputRef = useRef<HTMLInputElement>(null);
    const [searchPhraseInputValue, setSearchPhraseInputValue] = useState<string>(searchPhrase)
    const isMobile = useMediaQuery(theme.breakpoints.down("md"))

    return (
        <Box mb = {3} display = 'flex' flexDirection = 'column' alignItems = 'center' width = '100%' >
            <Image src = "/images/home/Isaco-logo.png" height = {120} width = {140} alt = "isacoLogo" style={{
                objectFit: 'contain',
            }} />
            <Typography fontSize = {18} fontWeight = {500} my = {2} color = {theme.palette.primary.main} >
                لیست کامل قطعات‌ شرکت ایساکو
            </Typography >

            <Stack
                spacing = {2}
                direction = {{xs: 'column', sm: 'row'}}
                height = {{md: 50, xs: "100%"}}
                display = "flex"
                justifyContent = "center"
                alignItems = "center"
                width={{md: '55%', sm: '70%', xs: '100%'}}
            >
                <Field.Text
                    sx = {{height: "100%", mr: 2}}
                    type = "search"
                    ref={inputRef}
                    fullWidth
                    closeIcon
                    value = {searchPhraseInputValue}
                    placeholder = "نام یا کد‌فنی قطعه را جستجو کنید..."
                    onChange = {event => {
                        const value = event.target.value;
                        setSearchPhraseInputValue(value);
                        if (value === "") {
                            handleSearchPhraseChange("");
                        }
                    }}
                    onKeyDown = {event => {
                        if (event.key === "Enter") {
                            event.preventDefault();
                            handleSearchPhraseChange(searchPhraseInputValue);

                            if (inputRef.current && isMobile) {
                                inputRef.current.blur();
                            }
                        }
                    }}
                />

                <LoadingButton
                    loading = {isLoading}
                    sx = {{width: 110, height: "100%", fontSize:16}}
                    variant = "contained"
                    onClick = {() => {
                        handleSearchPhraseChange(searchPhraseInputValue);
                        if (inputRef.current) {
                            inputRef.current.blur();
                        }
                    }}
                >
                    پیدا کن!
                </LoadingButton >
            </Stack >

        </Box >
    );
};

